const {
  REACT_APP_API_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_VERSION,
} = process.env

const ecoWeatherConfig = {
  label: 'Río Cuarto, Córdoba',
  lat: '-33.1243872',
  lon: '-64.4122296',
  timeZone: 'America/Argentina/Cordoba',
}

const oemWeatherConfig = {
  label: 'Villa Mercedes, San Luis',
  lat: '-33.1243872',
  lon: '-64.4122296',
  timeZone: 'America/Argentina/Cordoba',
}

const config = {
  API_URL: REACT_APP_API_URL,
  environment: REACT_APP_ENVIRONMENT,
  version: REACT_APP_VERSION,
  weather: {
    eco: ecoWeatherConfig,
    oem: oemWeatherConfig,
  },
}

export default config
